import React from "react";
import cx from "classnames";
import styles from "./Loading.module.scss";

export interface LoadingProps {
  className?: string;
}

export interface LoadingStatic {
  defaultChildren: React.ReactNode;
  setDefaultChildren: (children: React.ReactNode) => void;
}

const Loading: React.FC<LoadingProps> & LoadingStatic = ({ className, children }) => {
  return <div className={cx(styles.loading, className)}>{children || Loading.defaultChildren}</div>;
};

Loading.defaultChildren = <p>Loading...</p>;

Loading.setDefaultChildren = (children: React.ReactNode) => {
  Loading.defaultChildren = children;
};

export default Loading;
